export default __webpack_public_path__ + "static/media/SLIDE_CONCRECAM_2.87754ac4.jpg";